import React from 'react';
import NumberFormat from "react-number-format";
import PropTypes from "prop-types";
import InputMask from "react-input-mask";

export const CpfNumberFormatCustom = props => {
    const {
        inputRef,
        onChange,
        ...other
    } = props;

    return (
        <NumberFormat
            getInputRef={inputRef}
            onValueChange={values => {
                const {formattedValue, value} = values;

                onChange({
                    target: {
                        name: props.name,
                        value: formattedValue,
                    }
                });
            }}
            placeholder='___.___.___-__'
            format='###.###.###-##'
            mask={'_'}
            {...other} />
    );
};

CpfNumberFormatCustom.propTypes = {
    inputRef: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};

export const RgNumberFormatCustom = props => {
    const {
        onChange,
        inputRef, // Colocado aqui apenas para não ser adicionado ao InputMask, pois não existe esse atributo no componte.,
        ...other
    } = props;

    return (
        <InputMask
            mask="99.999.999-*"
            onChange={onChange}
            {...other} />
    );
};

RgNumberFormatCustom.propTypes = {
    inputRef: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};

export const CepNumberFormatCustom = props => {
    const {
        inputRef,
        onChange,
        ...other
    } = props;

    return (
        <InputMask
            mask="99999-999"
            onChange={onChange}
            {...other} />
    );
};

CepNumberFormatCustom.propTypes = {
    inputRef: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};

export const DataNascimentoNumberFormatCustom = props => {
    const {
        inputRef,
        onChange,
        ...other
    } = props;

    return (
        <NumberFormat
            getInputRef={inputRef}
            onValueChange={values => {
                const {formattedValue, value} = values;

                onChange({
                    target: {
                        name: props.name,
                        value: formattedValue,
                    }
                });
            }}
            placeholder='__/__/____'
            format='##/##/####'
            mask={'_'}
            {...other} />
    );
};

DataNascimentoNumberFormatCustom.propTypes = {
    inputRef: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};

export const TelefoneNumberFormatCustom = props => {
    const {
        onChange,
        inputRef, // Colocado aqui apenas para não ser adicionado ao InputMask, pois não existe esse atributo no componte.
        ...other
    } = props;

    return (
        <InputMask
            mask="(99) 9999-9999"
            onChange={onChange}
            {...other} />
    );
};

TelefoneNumberFormatCustom.propTypes = {
    inputRef: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};

export const CelularNumberFormatCustom = props => {
    const {
        onChange,
        inputRef, // Colocado aqui apenas para não ser adicionado ao InputMask, pois não existe esse atributo no componte.
        ...other
    } = props;

    return (
        <InputMask
            mask="(99) 99999-9999"
            onChange={onChange}
            {...other} />
    );
};

CelularNumberFormatCustom.propTypes = {
    inputRef: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};